import { AgGridReact } from '@ag-grid-community/react';
import { useAgGrid } from '@tassat/ag-grid';
import React from 'react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';

import { cellHeight, connectionsColumnDefs } from './apiConnectionsFirmGridOptions';

import type { IApiConnectionsFirmGridProps } from '.';

import './gridStyles.css';

export function ApiFirmConnectionsGrid (props: IApiConnectionsFirmGridProps) {
    const { apiConnections } = props;

    const [ ,onGridReady ] = useAgGrid();

    return (
        <div
            className='ag-theme-material'
            id='apiFirmsConnectionGrid'
            style={{ height: '100%' }}
        >
            <AgGridReact
                animateRows={false}
                columnDefs={connectionsColumnDefs}
                columnMenu='legacy'
                defaultColDef={{
                    resizable: false,
                    filter: false,
                    sortable: false
                }}
                enableCellTextSelection={true}
                onGridReady={onGridReady}
                rowData={apiConnections}
                rowHeight={cellHeight}
                suppressCellFocus={true}
                suppressContextMenu={true}
            />
        </div>
    );
}